const {required} = require("@common/react/cs-form/validators/required");

exports.singleKPIFormConfig = {
    fields: {
        title: {
            transforms: ["trim"],
            validators: [required],
            debounce: true,
        },
    },
};
